
import { Component, Vue } from "vue-property-decorator"
import { randomHexColor, getOptimalTextColor } from "@/helpers/data"
import { commonModule, labelModule } from "@/store/modules/store-accessor"
import LabelExistsAlert from "@/components/Alerts/LabelExistsAlert.vue";

@Component({
  components: {
    LabelExistsAlert,
  }
})
export default class AddExpenseLabelModal extends Vue {

  isAdding = false;

  labelModel = {
    name: '',
    color: randomHexColor()
  };

  labelExists = false;

  nameRules = [
    (val: any) => !!val || this.$i18n.t('nameRequired'),
    (val: any) => val.length <= 50 || this.$i18n.t('nameLengthRule'),
  ];

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  hideModal() {
    commonModule.hideModal();
  }

  get showNameOrPreview() {
    return this.labelModel.name || this.$i18n.t('labelPreview');
  }

  updateExists(value: boolean) {
    this.labelExists = value;
  }

  get canAdd() {
    return !(!this.labelExists && this.labelModel.name.replace(/ /g, '').replace(/-/g, '').length > 0);
  }


  async doAddExpenseLabel() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.isAdding = true;

      await labelModule.addExpenseLabel(this.labelModel);

      this.isAdding = false;
      this.hideModal();
    }
  }
}
